import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey40, spacing4 } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
const smallPadding = "2px";
const spacing54 = "54px";
const Wrapper = styled.div.withConfig({
  componentId: "sc-cb9hq5-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;visibility:hidden;animation:delay 0s linear forwards 1s;@keyframes delay{0%{visibility:hidden;}100%{visibility:visible;}}"]);
const SvgWrapper = styled.div.withConfig({
  componentId: "sc-cb9hq5-1"
})(["height:", ";width:", ";padding:", ";"], spacing54, spacing54, smallPadding);
const Track = styled.circle.withConfig({
  componentId: "sc-cb9hq5-2"
})(["fill:transparent;stroke:rgba(83,87,91,0.2);"]);
const Indicator = styled.circle.withConfig({
  componentId: "sc-cb9hq5-3"
})(["fill:none;stroke:", ";stroke-linecap:round;stroke-linejoin:round;transition:0.35s stroke-dashoffset;transform:rotate(-90deg);transform-origin:50% 50%;animation:spin 1.2s linear infinite;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], grey40);
const Description = styled(Text4).withConfig({
  componentId: "sc-cb9hq5-4"
})(["max-width:256px;text-align:center;margin-top:", ";"], spacing4);

const ProgressSection = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const percentage = 0.12;
  const sqSize = 50;
  const strokeWidth = 5; // SVG centers the stroke width on the radius, subtract out so circle fits in square

  const radius = (sqSize - strokeWidth) / 2; // Enclose circle in a circumscribing square

  const viewBox = `0 0 ${sqSize} ${sqSize}`; // Arc length at 100% coverage is the circle circumference

  const dashArray = radius * Math.PI * 2; // Scale 100% coverage overlay with the actual percent

  const dashOffset = dashArray - dashArray * percentage;
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(SvgWrapper, null, /*#__PURE__*/React.createElement("svg", {
    width: sqSize,
    height: sqSize,
    viewBox: viewBox,
    role: "progressbar",
    "aria-valuemin": "0",
    "aria-valuemax": "1"
  }, /*#__PURE__*/React.createElement(Track, {
    cx: sqSize / 2,
    cy: sqSize / 2,
    r: radius,
    strokeWidth: `${strokeWidth}px`
  }), /*#__PURE__*/React.createElement(Indicator, {
    cx: sqSize / 2,
    cy: sqSize / 2,
    r: radius,
    strokeWidth: `${strokeWidth}px`,
    style: {
      strokeDasharray: dashArray,
      strokeDashoffset: dashOffset
    }
  }))), children ? /*#__PURE__*/React.createElement(Description, null, children) : null);
};

ProgressSection.propTypes = {
  /** An explanation of why the user is waiting */
  children: PropTypes.node
};
export default ProgressSection;